module.exports = __webpack_public_path__ + "static/meta_runner-e41be7b7d85627eb2b9570198455858d.svg";